export const endpoints = {
  optionsCollection: (codetableId: number) => `optionsCollection/${codetableId}/search`,
  deleteCodeItem: (codetableId: number, codeId: number) => `optionsCollection/${codetableId}/code/${codeId}`,
  optionPath: (codetableId: number, codeId: number) => `optionsCollection/${codetableId}/code/${codeId}/path`,
  codesAccess: (codetableId: number) => `optionsCollection/${codetableId}/code/access`
};
